var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#B7976B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9104 15.0581C22.6586 15.2038 23.3462 15.569 23.8852 16.107C24.4242 16.6449 24.7901 17.3312 24.9361 18.0779M21.9104 12C23.4648 12.1724 24.9143 12.8671 26.0209 13.9702C27.1275 15.0733 27.8254 16.5191 28 18.0703M27.234 24.1712V26.4648C27.2349 26.6777 27.1912 26.8884 27.1057 27.0835C27.0203 27.2786 26.8949 27.4537 26.7377 27.5977C26.5805 27.7416 26.3949 27.8512 26.1928 27.9194C25.9908 27.9876 25.7766 28.013 25.5642 27.9938C23.2071 27.7382 20.943 26.9343 18.9537 25.6467C17.103 24.4729 15.5338 22.9068 14.3578 21.0596C13.0633 19.0651 12.2576 16.7943 12.0062 14.4312C11.9871 14.2198 12.0122 14.0067 12.0801 13.8055C12.148 13.6043 12.2571 13.4195 12.4005 13.2627C12.5439 13.1059 12.7184 12.9807 12.913 12.8949C13.1075 12.8091 13.3178 12.7647 13.5305 12.7645H15.8285C16.2002 12.7609 16.5606 12.8923 16.8425 13.1342C17.1243 13.3761 17.3084 13.7121 17.3605 14.0795C17.4574 14.8135 17.6373 15.5342 17.8966 16.2278C17.9997 16.5014 18.022 16.7988 17.9609 17.0847C17.8998 17.3706 17.7579 17.6331 17.552 17.8409L16.5792 18.8119C17.6696 20.7259 19.2574 22.3107 21.1751 23.399L22.1479 22.4281C22.3561 22.2225 22.6191 22.0809 22.9055 22.0199C23.192 21.9589 23.4899 21.9812 23.7641 22.084C24.4591 22.3429 25.1811 22.5224 25.9165 22.6192C26.2886 22.6716 26.6284 22.8587 26.8713 23.1448C27.1143 23.431 27.2433 23.7962 27.234 24.1712Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCircled);
export default __webpack_public_path__ + "static/media/phone-circled.cb45a63eb138573ad54619a66f70d666.svg";
export { ForwardRef as ReactComponent };